import { useQuery } from '@tanstack/vue-query'
import type { Ref } from 'vue'

import { explorerApi } from '~/api/client'
import type { EvmAddressInfo, EvmAddressListInfo } from '~/api/repository'
import { addressListKey } from '~/api/service/query-keys.const'
import { UNIT } from '~/environment-variables/unit.const'
import { AddressSummaryModel } from '~/types/model/address.model'
import type { IPagination } from '~/types/pagination.type'

export const useFetchAddressList = (pagination: Ref<IPagination>) => {
  return useQuery([ ...addressListKey, pagination ], (): Promise<ViewAddressList> => {
    return explorerApi.addressController.getAddressList1({
      requestBody: {
        page: pagination.value.page,
        size: pagination.value.rowPerPage
      }
    }).then((res) => {
      return new ViewAddressList(res as EvmAddressListInfo)
    })
  })
}

export type ViewAddressInfo = EvmAddressInfo & {
  balance: string;
  balancePercent: string;
  transactionCount: string;
}

export class ViewAddressList {
  private _rawData: EvmAddressListInfo
  private _totalCount: string
  private _viewCount: string
  private _addressList: Array<ViewAddressInfo>

  constructor(list: EvmAddressListInfo) {
    this._rawData = list
    this._totalCount = setComma(list.TCNT)
    this._viewCount = setComma(list.VCNT)
    this._addressList = list.ADDRLIST.map(address => {
      return {
        ...address,
        balance: setComma(setDigits(address.BL, 20)),
        balancePercent: setComma(setDigits(address.BLP, 11)),
        transactionCount: setComma(address.TRXCNT)
      }
    })
  }

  get TCNT() {
    return this._rawData.TCNT
  }

  get VCNT() {
    return this._rawData.VCNT
  }

  get totalCount() {
    return this._totalCount
  }

  get viewCount() {
    return this._viewCount
  }

  get addressList() {
    return this._addressList
  }

  get tokenHolderList() {
    return this._addressList.map(address => {
      return {
        holder: new AddressSummaryModel({
          ADDR: address.ADDR,
          ADT: address.ADDRT as any,
          NN: address.NM,
          SB: address.SB
        }),
        amount: address.balance + ' ' + UNIT,
        percentage: address.BLP,
        formattedPercentage: address.balancePercent + '%',
        uniqueTokenCount: '0',
        volatility: '+0.00%'
      }
    })
  }
}